function getToken() {
  return `Bearer ${localStorage.getItem('token')}`;
}
function getUser() {
  const user = localStorage.getItem('user');
  let username = '';

  try {
    username = JSON.parse(user).username;
  } catch (error) {
    console.log('No user in local storage');
  }
  return username;
}

export { getToken, getUser };
